import React from "react";
import klerData from "../../apis/klerData";
import zohoData from "../../apis/zohoData";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { createTextMask } from "redux-form-input-masks";

class AccountForm extends React.Component {
  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleCloseReload = () => {
    this.setState({ open: false });
    this.loadMenu();
  };

  render() {
    const phoneMask = createTextMask({
      pattern: "(999) 999-9999"
    });

    const updateZohoAccount = (id, data) => {
      // UPDATE ZOHO USER ACCOUNT
      console.log(JSON.stringify(data));
      zohoData
        .put(`/customers/${parseInt(id)}`, JSON.stringify(data))
        .then(result => {
          this.props.handleCloseReload();
        })
        .catch(error => console.log(error));
    };

    const updateGroup = formValues => {
      let updatedata = "";
      updatedata = updatedata + "{";
      updatedata = updatedata + 'FirstName: "' + formValues.FirstName + '",';
      updatedata = updatedata + 'LastName: "' + formValues.LastName + '",';
      updatedata = updatedata + 'Business: "' + formValues.Business + '",';
      updatedata = updatedata + 'Promo: "' + formValues.Promo + '",';
      updatedata = updatedata + 'ZohoId: "' + formValues.ZohoId + '",';
      updatedata = updatedata + 'Phone: "' + formValues.Phone + '"';
      updatedata = updatedata + "}";
      localStorage.setItem("UserBusiness", formValues.Business);
      if (formValues.Oid) {
        klerData
          .put(`/Subscription(${parseInt(formValues.Oid)})`, updatedata)
          .then(result => {
            updateZohoAccount(formValues.ZohoId, formValues);
          })
          .catch(error => console.log(error));
      } else {
        // console.log("CREATE");
        klerData
          .post(`/Subscription`, updatedata)
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      }
    };

    const onSubmit = formValues => {
      // console.log(formValues);
      updateGroup(formValues);
    };

    return (
      <div className="txt-center">
        <h4>Account</h4>
        <form onSubmit={this.props.handleSubmit(onSubmit)}>
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="ZohoId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="UserId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <div>
            <label>First Name</label>
            <div>
              <Field
                name="FirstName"
                component="input"
                type="text"
                placeholder="First Name"
                autoComplete="off"
              />
            </div>
          </div>
          <div>
            <label>Last Name</label>
            <div>
              <Field
                name="LastName"
                component="input"
                type="text"
                placeholder="Last Name"
                autoComplete="off"
              />
            </div>
          </div>
          <div>
            <label>Business Name</label>
            <div>
              <Field
                name="Business"
                component="input"
                type="text"
                placeholder="Business Name"
                autoComplete="off"
              />
            </div>
          </div>
          <div>
            <label>Phone</label>
            <div>
              <Field
                name="Phone"
                component="input"
                type="text"
                placeholder="Phone"
                autoComplete="off"
                {...phoneMask}
              />
            </div>
          </div>
          <div>
            <label>Promotional Code</label>
            <div>
              <Field
                name="Promo"
                component="input"
                type="text"
                placeholder="Promo Code"
                autoComplete="off"
              />
            </div>
          </div>

          <button className="waves-effect waves-light btn btn-small">
            Save
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // console.log(ownProps.data);
  return {
    initialValues: {
      Oid: ownProps.Oid,
      FirstName: ownProps.data.FirstName,
      LastName: ownProps.data.LastName,
      Business: ownProps.data.Business,
      Phone: ownProps.data.Phone,
      Promo: ownProps.data.Promo,
      ZohoId: ownProps.data.ZohoId,
      UserId: ownProps.UserId
    }
  };
};

const validate = formValues => {
  const errors = {};

  if (!formValues.FirstName) {
    errors.FirstName = "Please enter a group name";
  }

  return errors;
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "AccountForm",
    validate
  })(AccountForm)
);
